<template>
  <top-bar :currentPage="currentPage" :icsType="'ics'">
    <div class="">      
      <div class="search-bar-container">
        <div class="intro-text visible-md visible-lg" v-if="showIntro">{{ $t('main.INTRO') }}</div>

        <div class="autocomplete-container">
          <autocomplete-search
          :search-options="keywordsSearchOptions"
          :placeholder="$t('find.AGENT_INPUT_TEXT')"
          @keywords-change="updateKeywords"
          @keyword-input="updatePageFilter"
        /></div>

        <page-filter :page="currentPage" :keyword="keywordInput"/>      
      </div>

      <div class="filter-container">
        <ics-filter
          class="filter"
          :icsType="icsType"
          :canUnset="false"
          @change="updateIcs"
        ></ics-filter>

        <district-dropdown
          class="filter"
          :selected-ics="icsType"
          :selected-districts="districts || []"
          @changeDistrict="updateDistricts"
        />

        <agent-filter
          class="filter"
          :isMitaclub="isMitaclub"
          :isManager="isManager"
          :isSales="isSales"
          @changeAgentType="updateAgentType"
        ></agent-filter>

        <button
          class="btn btn-default btn-reset"
          type="button"
          @click="resetFilters">
          {{ $t('find.RESET') }}
        </button>
      </div>
    </div>
  </top-bar>
</template>

<script>
//import 'url-polyfill';
import { mapState, mapGetters, mapActions } from 'vuex';
import TopBar from '@/components/TopBar';
import PageFilter from '@/components/Home/Filters/Page';
import IcsFilter from '@/components/Stock/Filters/Ics';
import AgentFilter from '@/components/Agent/Filters/AgentType';
import DistrictDropdown from '@/components/Stock/Filters/DistrictDropdown';
import AutocompleteSearch from '@/components/Stock/AutocompleteSearch/DropdownInput';

export default {
  props: {
    showIntro: {
      default: () => false,
      type: Boolean,
    },
    icsType: {
      default: () => null,
    },
    districts: {
      default: () => [],
    },
    isMitaclub: {
      default: () => null,
    },
    isManager: {
      default: () => null,
    },
    isSales: {
      default: () => null,
    },
  },
  components: {
    TopBar,
    PageFilter,
    IcsFilter,
    AgentFilter,
    DistrictDropdown,
    AutocompleteSearch,
  },
  data () {
    return {
      currentPage: 'agent',
      keywordInput: null,
    }
  },
  computed: {
    ...mapState('stocksAutocompleteSearch', {
      keywords: state => state.selectedKeywords,
      isFetchingAutocomplete: state => state.isFetching,
      isFetchedAutocomplete: state => state.isFetched,
    }),
    keywordsSearchOptions() {
      return {
        icsType: this.icsType,
        keywordType: 'emp',
      };
    },
  },
  methods: {
    updateIcs(ics) {
      this.$emit('ics-change', ics);
    },
    updateKeywords() {
      this.$emit('keyword-change', null);
    },
    updateDistricts(districts) {
      this.$emit('district-change', districts);
    },
    updateAgentType(agentType) {
      this.$emit('agent-type-change', agentType);
    },
    resetFilters() {
      this.$emit('reset');
    },
    updatePageFilter(val) {
      this.keywordInput = val;
    },
  },
};
</script>

<style scoped>
.autocomplete-container {
  max-width: 600px;
}

.search-bar-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-bar-container > div {
  flex: 0;
}

.search-bar-container > div+div,
.filter-container  > div+div {
  padding-left: 10px;
}

.search-bar-container > .autocomplete-container {
  flex: 1;
}

.filter-container {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

 .filter-container .btn-reset {
  margin-left: auto;
 }

.btn.btn-reset,
.btn.btn-reset.btn-active
.btn.btn-reset:focus,
.btn.btn-reset:hover {
  background: #ffffbb;
  color: #000;
  outline: none;
}

.btn-reset{
  font-size: 16px;
}
</style>